
import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import ModalTitle from "@/lib/model/exam/modal-title";

// 面试链接
@Component
export default class ModalHeader extends Vue {
  @Prop({ type: ModalTitle }) modalTitle!: ModalTitle;
  @Prop({ type: String, default: "" }) modalType!: string;
  name = "modal-header";

  @Emit("on-add-cancel")
  handleClose() {
    console.log("on-add-cancel");
  }

  @Emit("on-notify-cancel")
  handleNoticeClose() {
    console.log("on-notify-cancel");
  }

  @Emit("on-recreate-cancel")
  handleReCreateClose() {
    console.log("on-recreate-cancel");
  }
}
